import { useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import HoverToolTip from "../HoverToolTip";


export default function ButtonField({label,definition,layoutObject,updateFunc,screenSize,extraClass,saveFunc}:AttributeFieldProps&{extraClass?:string}){







    let val = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize);

    let inx = 0; // set default to the left most button incase we can't find its value
  
    for(let i = 0;i<definition.options.length;i++){
    
      if(definition.options[i].value == val){
        inx = i;
        break;
      }
    }
    
    const [currentSlection,setSelection] = useState(inx);
    
    const updateAttribute =(newValue:string)=>{
   
  
      updateFunc(definition.attKey,newValue,definition.targetType);
      let index = (newValue.length<=0)?0:definition.options.length;
    
        for (let i = 0; i < definition.options.length; i++) {
          if (definition.options[i].value == newValue) {
            index = i;
            break;
          }
        }
    
        setSelection(index);
    }
    return (
      <div className={"wb-input-group "+(extraClass??"")+" "+definition.attKey.toLowerCase() }>
        {label&&definition.label&&
        <label className={(val=="")?"not-updated":"updated"}>{label}</label>
      }
        <div className="wb-input-row">
          {definition.options.map((option, index) => {
            let className = index == currentSlection ? "selected" : "";
    
            return (
              <button
                className={className}
                key={index}
                style={(option.label=="Auto"||(option.label as string).length>2)?{fontSize:"13px"}:{}}
                onClick={() => {
                  updateAttribute(option.value);
                  //save update for special cases
                  if(definition.attKey=="isLink"){
                    saveFunc();
                  }
                }}
              >
                {option.label}
                {option.toolTip && <HoverToolTip text={option.toolTip} checkScroll={true}/>}
              </button>
            );
          })}
        </div>
      </div>
    );

}